module.exports = __webpack_public_path__ + "img/chess_play_chess_game.444254e0.png";